import { Component, inject, input, InputSignal, OnInit, output } from "@angular/core";
import { CategoryHeader } from "../category-header/category-header";
import { SporsmalsType } from "../../types/SporsmalsType";
import { Flervalg } from "../flervalg/flervalg";
import { Envalg } from "../envalg/envalg";
import { ButtonComponent } from "@husbanken/designsystem-angular-core";
import { FeltAlternativ, FormRoot, ValideringsMeldingerService } from "@husbanken/designsystem-angular-forms";

@Component({
  selector: "bko-question",
  imports: [CategoryHeader, Flervalg, Envalg, ButtonComponent],
  templateUrl: "./question.html",
  styleUrl: "./question.scss",
})
export class Question implements OnInit {
  private valideringsMeldingerService = inject(ValideringsMeldingerService);

  readonly questionText: InputSignal<string> = input("Hvilke rom finnes på samme nivå som inngangen?");
  readonly helpText: InputSignal<string> = input(
    "Vi spør om dette for å kunne gi deg råd om hvordan boligen din kan tilpasses eller om det kan være lurt å vurdere en annen løsning.",
  );
  readonly questionType: InputSignal<SporsmalsType> = input(SporsmalsType.Envalg);
  readonly nextButtonText: InputSignal<string> = input.required();
  readonly currentCategoryNumber: InputSignal<number> = input.required();
  readonly totalNumberOfCategories: InputSignal<number> = input.required();
  readonly categoryTitle: InputSignal<string> = input.required();
  readonly categoryIconUri: InputSignal<string> = input.required();
  readonly categoryIconType: InputSignal<string> = input.required();
  readonly imageUri: InputSignal<string> = input(undefined);
  readonly imageType: InputSignal<string> = input(undefined);
  readonly currentQuestionNumber: InputSignal<number> = input.required();
  readonly totalNumberOfQuestionsInCategory: InputSignal<number> = input.required();
  readonly alternatives: InputSignal<FeltAlternativ[]> = input.required();
  readonly form: InputSignal<FormRoot> = input.required();

  previous = output<void>();
  next = output<void>();

  handleNextClick(): void {
    this.form().markAsSubmitted();
    if (this.form().invalid) {
      return;
    }

    this.next.emit();
  }

  handlePreviousClick(): void {
    this.previous.emit();
  }

  public ngOnInit(): void {
    this.valideringsMelding();
  }

  private valideringsMelding(): void {
    this.valideringsMeldingerService.leggTilMeldinger({
      control: {
        required: () => "Vennligst velg ett alternativ før du går videre.",
      },
    });
  }

  protected readonly SporsmalsType = SporsmalsType;
}
